export default __webpack_public_path__ + "4a4002394618b4b3742fe04bfc11ec49.png";